// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/assets/public/iconfont/iconfont.css
// module id = Fk1x
// module chunks = 73